import { apiGetAuth, apiPostAuth, apiPutAuth, apiDeleteAuth } from '@/utils/api'
import { API_USER_MANAGEMENT, API_DIGITAL_STAMP } from '@/utils/api-url'
import router from '@/router'

import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    stamps: { data: [] },
    detail_stamp: {},
    data_promo: {},
    detail_user: { data: [] },
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,
      title: '',
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_STAMP(state, payload) {
    state.stamps = payload
  },
  SET_DETAIL_STAMP(state, payload) {
    state.detail_stamp = payload
  },
  SET_DATA_PROMO(state, payload) {
    state.data_promo = payload
  },
  SET_DETAIL_USER(state, payload) {
    state.detail_user = payload
  },
  SET_DATA_MODAL_ADD_EDIT(state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD(state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER(state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListAllDetailUser(context, payload) {
    try {
      const response = await apiPostAuth(API_USER_MANAGEMENT.ALL_USERNAME, payload)
      context.commit('SET_DETAIL_USER', response.data.data)
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async getBankPayment() {
    try {
      const response = await apiGetAuth(API_DIGITAL_STAMP.GET_BANK_PAYMENT)
      return response.data.data
    } catch (error) {
      notificationDanger(error)
      return []
    }
  },
  async getListPromo(context, payload) {
    try {
      const response = await apiPostAuth(API_DIGITAL_STAMP.GET_PROMO_CODE, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListStamp(context, payload) {
    try {
      const response = await apiGetAuth(API_DIGITAL_STAMP.STAMP, payload)
      context.commit('SET_STAMP', response.data.data)
      context.commit('SET_META_FILTER', payload)
      router.push({ name: 'Stamps', query: payload })
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getDetailStamp(context, payload) {
    try {
      const response = await apiGetAuth(API_DIGITAL_STAMP.STAMP_DETAIL(payload))
      context.commit('SET_DETAIL_STAMP', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async bulkUploadProduct(context, payload) {
    try {
      const response = await apiPostAuth(API_DIGITAL_STAMP.BULK_UPLOAD_PRODUCT, payload)
      return response.data.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async bulkUploadSponsoredProduct(context, payload) {
    try {
      const response = await apiPostAuth(API_DIGITAL_STAMP.BULK_UPLOAD_SPONSORED_PRODUCT, payload)
      return response.data.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async createStamp(context, payload) {
    try {
      const response = await apiPostAuth(API_DIGITAL_STAMP.STAMP, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateStamp(context, { id, reqBody }) {
    try {
      const response = await apiPutAuth(API_DIGITAL_STAMP.STAMP_UPDATE_DELETE(id), reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async deleteStamp(context, payload) {
    try {
      const response = await apiDeleteAuth(API_DIGITAL_STAMP.STAMP_UPDATE_DELETE(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  list_stamps(state) {
    return state.stamps
  },
  list_detail_stamp(state) {
    return state.detail_stamp
  },
  list_data_promo(state) {
    return state.data_promo
  },
  list_detail_users(state) {
    return state.detail_user
  },
  get_data_modal_add_edit(state) {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard(state) {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter(state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
